import React from "react";

const Transaction = ({ transactions }) => {
  const transactionsStatu = (index) => {
    switch (transactions[index].main_status) {
      case 0:
        return "موفق";
      case 1:
        return "ناموفق";
      default:
        return "NaN";
    }
  };
  return transactions.map((value, index) => {
    return (
      <>
        <div
          className="item details d-lg-flex d-none"
          key={`transaction${index * 2}`}
        >
          <div className="itemValue col-4">{value.amount}</div>
          <div className="itemValue col-4">{value.date}</div>
          <div className="itemValue col-4">{transactionsStatu(index)}</div>
        </div>
        <div
          className="headers_table d-flex d-lg-none flex-wrap"
          key={`transaction${index * 2 + 1}`}
        >
          <div className="item col-12 col-md-6">
            مبلغ : <span className="itemValue">{value.amount}</span>
          </div>
          <div className="item col-12 col-md-6">
            زمان : <span className="itemValue">{value.date}</span>
          </div>
          <div className="item col-12 col-md-6">
            وضعیت :{" "}
            <span className="itemValue">{transactionsStatu(index)}</span>
          </div>
        </div>
      </>
    );
  });
};

export default Transaction;
